module.exports = __webpack_public_path__ + "static/powerbi-merge-values-apply-974f3422c85b097169a40f44e79ac18c.png";